export const CompanySectionTop = ({ children }: { children: React.ReactNode }) => (
  <div className="company-content-top company-section-text description">{children}</div>
);
